<template>
  <div class="left-menu">
    <div class="logo-con">
      <a style="color:white;cursor:pointer;font-size:14px;font-size:normal;" @click="redirect('/')">CASEDIY ERP</a>
    </div>
    <ul class="ul">
      <li :class="[current == 'index' ? 'current' : '']" @click="redirect('/')">
        <i class="el-icon-stopwatch"></i>
        <a>首页</a>
      </li>
      <li
        v-if="uid === 1"
        :class="[current == 'diy' ? 'current' : '']"
        @click="redirect('/diy')"
      >
        <i class="el-icon-sell"></i>
        <a>建模</a>
      </li>
      <li
        v-if="user_powers.indexOf(power_tag_goods) != -1 || uid === 1"
        :class="[current == 'goods' ? 'current' : '']"
        @click="redirect('/goods')"
      >
        <i class="el-icon-collection"></i>
        <a>商品</a>
      </li>
      <li
        v-if="user_powers.indexOf(power_tag_crop) != -1 || uid === 1"
        :class="[current == 'crop' ? 'current' : '']"
        @click="redirect('/crop')"
      >
        <i class="el-icon-collection"></i>
        <a>素材</a>
      </li>
      <li
        v-if="user_powers.indexOf(power_tag_order) != -1 || uid === 1"
        :class="[current == 'orders' ? 'current' : '']"
        @click="redirect('/orders')"
      >
        <div class="h3-div-left">
          <i class="el-icon-tickets"></i>
          <a>订单</a>
        </div>
        <ul class="sub-list-ul">
          <li v-if="uid === 1" @click="redirect('/orders/visitor', true)" :class="[current_menu_sub == 'visitor' ? 'active' : '']"><a>访客</a></li>
          <li v-if="uid === 1" @click="redirect('/orders/customer', true)" :class="[current_menu_sub == 'customer' ? 'active' : '']"><a>客户</a></li>
          <li v-if="uid === 1" @click="redirect('/orders/diy-create', true)" :class="[current_menu_sub == 'create' ? 'active' : '']"><a>作品</a></li>
          <li v-if="uid === 1" @click="redirect('/orders/diy-prompt', true)" :class="[current_menu_sub == 'prompt' ? 'active' : '']"><a>特效</a></li>
          <li v-if="uid === 1" @click="redirect('/orders/submit', true)" :class="[current_menu_sub == 'submit' ? 'active' : '']"><a>提交</a></li>
          <li v-if="uid === 1" @click="redirect('/orders/cart', true)" :class="[current_menu_sub == 'cart' ? 'active' : '']"><a>加购</a></li>
          <li v-if="uid === 1" @click="redirect('/orders/cart/preview', true)" :class="[current_menu_sub == 'cart_preview' ? 'active' : '']"><a>预览</a></li>
          <li v-if="uid === 1" @click="redirect('/orders/abandoned', true)" :class="[current_menu_sub == 'abandoned' ? 'active' : '']"><a>弃单</a></li>
          <li @click="redirect('/orders', true)" :class="[current_menu_sub == 'orders' ? 'active' : '']"><a>订单</a></li>
        </ul>
      </li>
      <li
        v-if="uid === 1" 
        :class="[current == 'marketing' ? 'current' : '']"
        @click="redirect('/marketing')"
      >
        <i class="el-icon-eleme"></i>
        <a>推广</a>
      </li>
      <li
        v-if="uid === 1" 
        :class="[current == 'email' ? 'current' : '']"
        @click="redirect('/email')"
      >
        <i class="el-icon-eleme"></i>
        <a>客服</a>
      </li>
      <li
        v-if="uid === 1"
        :class="[current == 'factory' ? 'current' : '']"
        @click="redirect('/factory')"
      >
        <i class="el-icon-cherry"></i>
        <a>工厂</a>
      </li>
      <li
        v-if="uid === 1"
        :class="[current == 'logistics' ? 'current' : '']"
        @click="redirect('/logistics')"
      >
        <i class="el-icon-truck"></i>
        <a>物流</a>
      </li>
      <li
        v-if="uid === 1"
        :class="[current == 'customers' ? 'current' : '']"
        @click="redirect('/customers')"
      >
        <i class="el-icon-user"></i>
        <a>客户</a>
      </li>
      <li
        v-if="uid === 1"
        :class="[current == 'setting' ? 'current' : '']"
        @click="redirect('/setting')"
      >
        <i class="el-icon-setting"></i>
        <a>设置</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["active"],
  computed: {
    is_root() { 
      var apps_options = this.$store.state.public.cfg.apps_options
      for (var i = 0; i < apps_options.length; i++) {
        if (apps_options[i].label == 'casedrawing') {
          return true
        }
      }
      return false
    },
    current() { 
      return this.$store.state.public.current_menu
    },
    current_menu_sub() { 
      return this.$store.state.public.current_menu_sub
    },
  },
  data(){
      return {
        uid:0,
        power_tag_goods:"06f57e4f4e2d54b447868cf45f96685b",
        power_tag_crop:"1b1855f71654ae235d0ba220c60a98d6",
        power_tag_order:"a584298ba71632cffac8e62d24106fbb",
        power_tag_purchase:"67edaa16a8c6c62b1e0c45e8fd428b8f",
        user_powers:[],
      }
  },
  mounted() { 
    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
        this.uid = parseInt(localStorage.getItem("uid"));
    }
    var pt = localStorage.getItem("pt");
    if ( pt ) {
      this.user_powers = pt.split(",")
    }
  },
};
</script>
<style scoped>
.left-menu {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 111px;
  background: #333;
  color: #efefef;
  z-index: 11;
}
.left-menu .logo-con {
  height: 44px;
  text-align: center;
  border-bottom: 1px solid #666;
  box-sizing: border-box;
  padding-top: 10px;
}
.left-menu .logo-con .el-icon-s-goods {
  font-size: 20px;
}
.left-menu .ul > li {
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.left-menu .ul > li:active,
.left-menu .ul > li.current {
  background: #000;
  color: #fff;
}
.left-menu .ul > li a {
  color: #efefef;
  font-size: 12px;
}
.left-menu .sub-list-ul{margin-left: 10px;margin-top: 10px;}
.left-menu .sub-list-ul li{padding: 5px;box-sizing: border-box;color: gray;}
.left-menu .sub-list-ul li a{color: gray;}
.left-menu .sub-list-ul li.active a{color: #efefef;}
</style>



// WEBPACK FOOTER //
// src/pages/public/_left.vue